import React, { useState, useEffect} from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import * as FaIcons from "react-icons/fa";
import Cargando from "../../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Nav from 'react-bootstrap/Nav';
import { Link } from "react-router-dom";
import SinPermisos from "./../../components/sinpermisos";


const url = "https://api.sstrade.us/public/depositostodos";
const urldp = "https://api.sstrade.us/public/depositospro";
const urldel = "https://api.sstrade.us/public/depositosdelete";
const urldq = "https://api.sstrade.us/public/depositoquitado";



const Paises = () => {

  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: '',
   fecha: '',
    idusuario: '',
    cantidad: '',
    walletorigen: '',
    txid: '',
    status: ''
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  const columns = [
    {
      name: 'Accion',
      button: true,
      cell: (row) =>
        <Nav>
        <button className="btn btn-default"
        onClick={() => { setDatosSeleccionados(row); abrirModalEditar() }} 
        >
        <FaIcons.FaRegEdit/>
        </button>&nbsp;&nbsp;&nbsp;    
    
        <button  onClick={() => { setDatosSeleccionados(row); abrirModalDelete() }}  className="btn btn-default"> <FaIcons.FaTrash/></button>     

      </Nav>
    },
    {
      name: 'Id',
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: 'TxID',
      selector: (row) => row.txid,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: 'status',
      selector: (row) => row.status,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: 'Trabajador',
      selector: (row) => row.nombret,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: 'Correo',
      selector: (row) => row.correo,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: 'Cantidad',
      selector: (row) => row.cantidad,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: 'Banco',
      selector: (row) => row.walletorigen,
      defaultSortAsc: true,
      sortable: true,
    },
    
  ];
  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    const result = data.filter((resultdata) => {
      if(resultdata.correo.toLowerCase().match(buscar.toLowerCase())||
      resultdata.walletorigen.toLowerCase().match(buscar.toLowerCase())||
      resultdata.txid.toLowerCase().match(buscar.toLowerCase())||
      resultdata.nombret.toLowerCase().match(buscar.toLowerCase())
      ){
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);



  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    console.log(users.id);
    await axios.get(url).then(response => {
      console.log(response.data);
      setData(response.data);
      setFiltroBuscar(response.data);
      console.log(response.data);
    })
  }
  
  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser')
    if(loginUserJSON){
      const user= JSON.parse(loginUserJSON)
      setUsers(user);
    }
   }, []);

  // eslint-disable-next-line
  useEffect(async () => {
    await peticionGet();
  }, [users]);


  ///////////////Insertar Datos//////////////////////////////////
  const [modalInsertar, setModalInsertar] = useState(false);
 

  const handleChange = e => {
    const { name, value } = e.target;
    setDatosSeleccionados(prevState => ({
      ...prevState,
      [name]: value
    }))

  }

  const [Error, setError] = useState(false);

  const peticionPost = async () => {
    delete datosSeleccionados.id;
    console.log(datosSeleccionados);
    await axios.post(url,datosSeleccionados).then(res => {
      peticionGet();
      setError(false);
      setModalInsertar(false);
    })
      .catch((err) => {
        setError(true);
        setModalInsertar(false);
      })
  }

  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    console.log(datosSeleccionados);
    setModalEditar(true);
  }

  const peticionPut = async () => {
    console.log(datosSeleccionados);
    await axios.put(urldp+'/'+datosSeleccionados.id,datosSeleccionados).then(response => {
      peticionGet();
      setError(false);
      setModalEditar(false);
    })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditar(false);
      })
  }

  const peticionPutquitado= async () => {
    console.log(datosSeleccionados);
    await axios.post(urldq,datosSeleccionados).then(res => {
      peticionGet();
    })
      .catch((err) => {
        setError(true);
        setModalEditar(false);
      })
  }


  const [modalDelete, setModalDelete] = useState(false);
  const abrirModalDelete = () => {
    setModalDelete(true);
  }

  const peticionDelete = async () => {
    await axios.delete(urldel+'/'+datosSeleccionados.id).then(response => {
      peticionPutquitado();
      peticionGet();
      setError(false);
      setModalDelete(false);
    })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalDelete(false);
      })
  }


  /////////////////////////////////////////////////////////////////
  if(users.rol!==undefined){
    if(users.rol==='admin'){
        return (
          <div>
            <div className="Almacen">
              <Sidebar>
                <Card>
                  <Card.Header className="bg-dark text-white" as="h3">
                    <div className='row'>
                      <div className='col-md-6'>
                       Todos los Depositos
                      </div>
                      
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Card.Title>Depositos reclamados por ti</Card.Title>
                    {
                      Error &&
                      <div className="alert alert-danger">
                        {<strong>Error: El nombre ya existe! intente con otro nombre.</strong>}
                      </div>
                    }
                    <p>Estos son los depositos que reclamaste para procesar, si el deposito no se procesa luego de una hora volvera a estar disponible
                    para ser procesado por otro usuario. </p>
                    <DataTable
                      columns={columns}
                      data={filtrobuscar}
                      noDataComponent="No hay elementos a mostrar"
                      progressPending={pending}
                      progressComponent={<Cargando />}
                      pagination
                      paginationComponentOptions={paginationComponentOptions}
                      subHeader
                      subHeaderComponent={
                        <input
                          type="text"
                          placeholder="Buscar"
                          className="w-25 form-control"
                          value={buscar}
                          onChange={(e) => setBuscar(e.target.value)}
                        />
                      }
                    />
      
                    <Modal isOpen={modalDelete}>
                      <ModalHeader>
                        <div>
                          <h4>Eliminar deposito</h4>
                        </div>
                      </ModalHeader>
                      <ModalBody>
                     
                <div className="form-group">
                          <h5>¿Desea eliminar al el deposito #{datosSeleccionados.id}? </h5>
                 </div>
                      </ModalBody>
                      <ModalFooter>
                        <button
                          className="btn btn-dark"
                          onClick={() => setModalDelete(false)}
                        >
                          Cancelar
                        </button>
                        <button className="btn btn-danger"
                          onClick={() => peticionDelete()}>
                          Eliminar
                        </button>
      
                      </ModalFooter>
                    </Modal>
      
                    <Modal isOpen={modalEditar}>
                      <ModalHeader>
                        <div>
                          <h4>Procesar deposito</h4>
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        <div className="form-group">
                          <input
                            className="form-control" readOnly
                            type="hidden"
                            name="id"
                            value={datosSeleccionados.id}
                            onChange={handleChange}
                          />
                          <input
                            className="form-control" readOnly
                            type="hidden"
                            name="id"
                            value={datosSeleccionados.idusuario}
                            onChange={handleChange}
                          />

                         <label>Cantidad USDT</label>
                          <input
                          readOnly
                            className="form-control"
                            type="text"
                            name="nombre"
                            value={datosSeleccionados.cantidad}
                            onChange={handleChange}
      
                          />
                                 <br /><br />
                                 <label>Wallet de deposito</label>
                          <input
                          readOnly
                            className="form-control"
                            type="text"
                            name="nombre"
                            value={datosSeleccionados.walletorigen}
                            onChange={handleChange}
      
                          />
                                 <br /><br />
      
                          <label>TxID</label>
                          <input
                          readOnly
                            className="form-control"
                            type="text"
                            name="nombre"
                            value={datosSeleccionados.txid}
                            onChange={handleChange}
      
                          />
      
                          <br /><br />
      
                          <label>Status del deposito</label>
                          <select className='form-control' value={datosSeleccionados.status} name='status' id="setalmacen" onChange={handleChange}>
                          <option>Seleccione una opcion</option>
                            <option value={'Procesado'}>Procesar</option>
                            <option value={'Cancelado'}>Cancelar</option>
                            <option value={'Liberado'}>Liberar</option>
                          </select>
      
      
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <button
                          className="btn btn-dark"
                          onClick={() => setModalEditar(false)}
                        >
                          Cancelar
                        </button>
                        <button className="btn btn-success" onClick={() => peticionPut()}>
                          Actualizar
                        </button>
                      </ModalFooter>
                    </Modal>
                  </Card.Body>
                </Card>
              </Sidebar>
            </div>
          </div>
     
      );
    }
    else{
      return (
        <div>
        <Sidebar>
           <SinPermisos/>
         </Sidebar>  
        </div>
      );
    }}
    else{
      return (
        <div>
        <Sidebar>
           <SinPermisos/>
         </Sidebar>  
        </div>
      );
    }
    };
    export default Paises;